import axios from "axios"
import mapDocumentoToPdf from "common/mappers/mapDocumentoToPdf"
import mapFacturaRecurrenteToPost from "common/mappers/mapFacturaRecurrenteToPost"
import { DEFAULT_CURRENCY_SYMBOL } from "features/Contactos/constants"

const FacturaRecurrenteService = {
  getFacturasRecurrentes(queryParam: $TSMigrationFixMe) {
    return axios.get(`/FacturaRecurrente/by-filters${queryParam}`)
  },
  getById(id: $TSMigrationFixMe) {
    return axios.get(`/FacturaRecurrente/${id}`)
  },
  deleteFacturaRecurrente(id: $TSMigrationFixMe) {
    return axios.delete(`/FacturaRecurrente/${id}`)
  },
  editFacturaRecurrente(
    factura: $TSMigrationFixMe,
    observacionCesion: $TSMigrationFixMe,
    cuentaContableFactura: $TSMigrationFixMe
  ) {
    const postFactura = mapFacturaRecurrenteToPost(
      factura,
      false,
      observacionCesion,
      cuentaContableFactura
    )

    return axios.put(`/FacturaRecurrente/${factura.id}`, postFactura)
  },
  createFacturaRecurrente(data: $TSMigrationFixMe) {
    return axios.post(`/FacturaRecurrente/`, data)
  },

  getArchivosAdjuntosById(id: $TSMigrationFixMe) {
    return axios.get(`/FacturaRecurrente/${id}/ficheros-adjuntos`)
  },

  getFacturasRecurrentesHistoricas(
    id: $TSMigrationFixMe,
    queryParam: $TSMigrationFixMe
  ) {
    return axios.get(
      `/FacturaRecurrente/historico-by-filters/${id}${queryParam}`
    )
  },

  getPdfById(id: $TSMigrationFixMe) {
    return axios.get(`/FacturaRecurrente/generate-pdf/${id}`, {
      responseType: "blob",
    })
  },
  postFactura(
    factura: $TSMigrationFixMe,
    observacionCesion: $TSMigrationFixMe,
    cuentaContableFactura: $TSMigrationFixMe
  ) {
    const postFactura = mapFacturaRecurrenteToPost(
      factura,
      false,
      observacionCesion,
      cuentaContableFactura
    )
    return axios.post("/FacturaRecurrente", postFactura)
  },
  deleteArchivoAdjunto(
    facturaID: $TSMigrationFixMe,
    fileID: $TSMigrationFixMe
  ) {
    return axios.delete(`/FacturaRecurrente/${facturaID}/fichero/${fileID}`)
  },

  getPdf(
    factura: $TSMigrationFixMe,
    observacionCesion: $TSMigrationFixMe,
    tiposImpuestosArticulos: $TSMigrationFixMe,
    totalRetencion: $TSMigrationFixMe,
    tiposImpuestosGenerales: $TSMigrationFixMe
  ) {
    const postFactura = mapDocumentoToPdf(
      factura,
      false,
      observacionCesion,
      tiposImpuestosArticulos,
      factura?.divisa,
      totalRetencion,
      tiposImpuestosGenerales
    )
    // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable...
    const { simbolo = "" } = JSON.parse(localStorage.getItem("divisas")).find(
      (currency: $TSMigrationFixMe) => currency.abreviatura === factura.divisa
    )

    postFactura.divisa = simbolo || DEFAULT_CURRENCY_SYMBOL

    return axios.post("/FacturaRecurrente/generate-pdf", postFactura, {
      responseType: "blob",
    })
  },

  addNewArchivoAdjunto(facturaID: $TSMigrationFixMe, file: $TSMigrationFixMe) {
    return axios.post(`/FacturaRecurrente/${facturaID}/fichero-adjunto`, file)
  },
  omitFacturaRecurrente(
    id: $TSMigrationFixMe,
    fechaOmision: $TSMigrationFixMe
  ) {
    return axios.post(
      `FacturaRecurrente/${id}/omitir/fechaOmision/${fechaOmision}`
    )
  },
}

export default FacturaRecurrenteService
